import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "waiting--sprite",
  "use": "waiting--sprite-usage",
  "viewBox": "0 0 8 14",
  "content": "<symbol viewBox=\"0 0 8 14\" xmlns=\"http://www.w3.org/2000/svg\" id=\"waiting--sprite\">\n<path d=\"M0 0.333344L0.00666682 4.33334L2.66667 7.00001L0.00666682 9.67334L0 13.6667H8V9.66668L5.33333 7.00001L8 4.34001V0.333344H0ZM6.66667 10V12.3333H1.33333V10L4 7.33334L6.66667 10Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol